import Alpine from "alpinejs";
import { dispatch } from "../utils/events.ts";

interface IContentReUpload {
  BlockIndex: number;
  Length: number;
  TargetId?: number;
}

const contentRange: Alpine.DirectiveCallback = (el, _, { cleanup }) => {
  const obs = new MutationObserver(() => {
    const blocks = Array.from(el.querySelectorAll("[data-block-index]"))
      .map((e) => parseInt(e.getAttribute("data-block-index")!))
      .sort((a, b) => a - b);

    const index = blocks[0];
    const length = blocks[blocks.length - 1] - index;
    let content: IContentReUpload = { BlockIndex: index, Length: length };

    const targetElem = el.querySelector("[data-id].selected");
    if (targetElem !== null) {
      content.TargetId = parseInt(targetElem.getAttribute("data-id")!);
    }

    dispatch("content-scroll-range", { index, length });
  });

  obs.observe(el, {
    childList: true,
  });

  cleanup(() => {
    obs.disconnect();
  });
};
export default contentRange;
